import { useEffect } from "react";
import { initMetaPixelTracking } from "@/utils/metaPixel";

/**
 * Activa la delegación global de clics para el Píxel de Meta.
 * Un solo listener en `document`: funciona aunque algún bloque se
 * renderice dinámicamente más adelante.
 */
export function useMetaPixelTracking(): void {
  useEffect(() => initMetaPixelTracking(), []);
}